<template>
  <base-popup ref="popupNotification" class="popup-notification">
    <template #icon>
      <svg
        width="8"
        height="36"
        viewBox="0 0 8 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.99902 30.0039C5.10359 30.0039 5.99902 30.8993 5.99902 32.0039L5.99902 33.0039C5.99902 34.1085 5.10359 35.0039 3.99902 35.0039C2.89445 35.0039 1.99902 34.1085 1.99902 33.0039L1.99902 32.0039C1.99902 30.8993 2.89445 30.0039 3.99902 30.0039Z"
          fill="#F2F2F2"
        />
        <path
          d="M0.510912 3.97101C0.239473 1.86737 1.87794 0.00390625 3.99903 0.00390625C6.12012 0.00390625 7.75858 1.86737 7.48714 3.97102L4.9908 23.3176C4.84078 24.4803 3.15728 24.4803 3.00725 23.3176L0.510912 3.97101Z"
          fill="#F2F2F2"
        />
      </svg>
    </template>
    <template #content>
      <div v-if="custom" class="custom-block">
        <div class="custom-block__title">
          <span>{{ $t('error-notification.title') }}</span>
        </div>
        <div class="custom-block__description">
          <span>{{ displayCustomText }}</span>
        </div>
        <div class="custom-block__action">
          <div class="close-btn">
            <primary-button
              :label="$t('error-notification.close')"
              @click="closePopup"
            ></primary-button>
          </div>
        </div>
      </div>
      <span v-else v-html="displayMessage"></span>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'

export default {
  name: 'ErrorNotification',
  components: { BasePopup, PrimaryButton },
  props: {
    text: {
      type: String,
    },

    custom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeoutHandler: null,
      message: null,
      localCustomText: '',
      errorMessages: {
        equal: 'wallets_are_equal',
        to_wallet: 'to_wallet_not_found',
        from_wallet: 'from_wallet_not_found',
        from_partner: 'need_select_from_partner',
        to_partner: 'need_select_to_partner',
        to_sub_wallet: 'to_sub_wallet_not_found',
        from_sub_wallet: 'from_sub_wallet_not_found',
        transfer: 'error_create_transfer',
        pushner_error: 'pushner_error',
      },
    }
  },

  computed: {
    displayMessage() {
      return this.message ? this.message : this.text
    },

    displayCustomText() {
      return this.localCustomText ? this.localCustomText : ''
    },
  },

  methods: {
    async openCustomPopup(errorMessage) {
      const errorCode = Object.keys(errorMessage)[0]
      this.localCustomText = this.errorMessages[errorCode] || errorMessage

      return await this.$refs.popupNotification.open()
    },

    show(timeoutSeconds = 2, text = null) {
      this.removeTimeoutHandler()

      let _timeToShow = timeoutSeconds * 1000

      this.message = text

      this.timeoutHandler = setTimeout(() => {
        this.$refs.popupNotification.close()
      }, _timeToShow)

      return this.$refs.popupNotification.open()
    },
    removeTimeoutHandler() {
      if (this.timeoutHandler) {
        clearInterval(this.timeoutHandler)
      }
    },

    async closePopup() {
      return await this.$refs.popupNotification.close()
    },
  },

  beforeUnmount() {
    this.removeTimeoutHandler()
  },
}
</script>

<style lang="scss" scoped>
.popup-notification {
  :deep(.popup) {
    position: relative;
    width: 341px !important;
    max-width: 100%;
    background: #ffffff;
    border-radius: 40px;
    padding: 75px 20px 40px !important;
    box-shadow: 0px 20px 30px rgb(225 235 253 / 38%);

    .popup__icon {
      position: absolute;
      width: 70px;
      height: 70px;

      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #64748B;
      border-radius: 50%;
      top: -25px;
      left: 50%;
      transform: translateX(-50%);

      box-shadow: -10px 13px 26px rgba(43, 101, 235, 0.2),
        inset 0px -7px 0px rgba(0, 0, 0, 0.25);

      :deep(svg) {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .popup__content {
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      text-align: center;
      color: #27365b;
    }

    .popup__actions {
      margin-top: 35px;

      &:empty {
        margin-top: 0;
      }
    }
  }
}
.custom-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .custom-block__title {
    span {
      font-weight: 700;
    }
  }
  .custom-block__description {
    line-height: 20px;
    span {
      font-weight: 500;
      font-size: 14px;
    }
  }

  .custom-block__action {
    width: 210px;
    margin: 20px auto 0;
  }
}
</style>
